export default __webpack_public_path__ + "static/media/mafin.e9f1d27e.svg";